import { ExecuteEndpoint } from '../../components/common/BaseApiService';
import { IdNamePair } from '../../Model/IdNamePair';

export class LocalesService {
  public async getLocales(): Promise<IdNamePair[]> {
    return ExecuteEndpoint('locales', 'GET');
  }
}
